export const AdSenseSlotDivNames = {
    slot12: 'slot12',
    slot15: 'slot15',
    afscontainer1: 'afscontainer1',
    afscontainer2: 'afscontainer2',
} as const;

export type AdSenseSlotDivName = typeof AdSenseSlotDivNames[keyof typeof AdSenseSlotDivNames];

export const AdSenseSlotContainerNames = {
    slot12Container: 'slot12-container',
    slot15Container: 'slot15-container',
    afscontainer1: 'afscontainer1',
    afscontainer2: 'afscontainer2',
};

export const getContainerNameBySlotId = (slotId: string) => {
    if (slotId === AdSenseSlotDivNames.slot12) {
        return AdSenseSlotContainerNames.slot12Container;
    }

    return undefined;
};
